import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { MCard } from "components/Shared";
import Grid from "@mui/material/Grid";
import { getAuditDeterminationResults } from "requests/qaCaseAudit/index.ts";

const QaCaseAuditWarning = ({
  controlNumber,
}) => {
  const mounted = useRef(true);

  const [isFetchingAuditDetermination, setIsFetchingAuditDetermination] = useState(false);
  const [auditDetermination, setAuditDetermination] = useState({});

  useEffect(() => {
    setIsFetchingAuditDetermination(true);
    getAuditDeterminationResults(controlNumber, (data) => {
      setAuditDetermination(data);
      setIsFetchingAuditDetermination(false);
    }, mounted);

    return () => { mounted.current = false; };
  }, []);

  const getResultFields = () => {
    let warnings = [{
        label: "Manager Review Required",
        value: "    ",
      }];
    if(auditDetermination.auditRequiredForInspector){
      warnings.push({
        label: "New Inspector",
        value: "    "
      });
    }
    if(auditDetermination.auditRequiredForCustomer){
      warnings.push({
        label: "New Customer",
        value: "    "
      });
    }
    if(auditDetermination.auditRequiredForQaAgent){
      warnings.push({
        label: "New QA Agent",
        value: "    "
      });
    }    
    return warnings;
  }; 

  if(!isFetchingAuditDetermination && !auditDetermination?.auditRequired) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <MCard title={"QA Warning"}
        isFetching={isFetchingAuditDetermination}
        fields={getResultFields()}
      />
    </Grid>    
  );
};

QaCaseAuditWarning.propTypes = {
  controlNumber: PropTypes.number.isRequired,
};

export default QaCaseAuditWarning;